module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Clip-f3d791bb9c9d384ba00abb62b84b5ffa.svg";